<ng-container *ngIf="permConfig.isAddAllowed">
<div class="container-fluid">
    <app-page-title title="AWB Configuration"></app-page-title>
    <div class="row">
        <div class="col-md-12">
            <div class="card">

                <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills bg-light rounded nav">
                    <li [ngbNavItem]="1">
                        <a ngbNavLink (click)="isStockTabActive = true">
                            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                            <span class="d-none d-sm-block">Stocks</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="StocksContent"></ng-template>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2">
                        <a ngbNavLink (click)="isStockTabActive = false">
                            <span class="d-block d-sm-none"><i class="fas fa-gear"></i></span>
                            <span class="d-none d-sm-block">Config</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="Config"></ng-template>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="justifiednav"></div>
                <ng-template #StocksContent>
                    <form [formGroup]="awbStockForm" (ngSubmit)="addStock()"
                        (keydown.enter)="useEnterKey ? $event.preventDefault() : addStock()">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="company" class="form-label">Company </label>
                                    <ng-select id="company" placeholder="Select" [items]="companyList"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCompanies" bindLabel="name"
                                        [bindValue]="'id'"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        appEnterDirective [onEnterKey]="useEnterKey">
                                    </ng-select>

                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="servicecenter" class="form-label">Service Center </label>
                                    <ng-select id="servicecenter" placeholder="Select" [items]="serviceCenterList"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlServiceCenters" bindLabel="name"
                                        [bindValue]="'id'"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        appEnterDirective [onEnterKey]="useEnterKey">
                                    </ng-select>

                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="customer" class="form-label">Customer </label>
                                    <ng-select id="customer" placeholder="Select" [items]="customerList"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCustomers" bindLabel="name"
                                        [bindValue]="'id'"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        appEnterDirective [onEnterKey]="useEnterKey">
                                    </ng-select>

                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-2">
                                <div class="mb-2">
                                    <label class="form-label">Prefix
                                        (<small><i class="mdi mdi-information">Note: alphabets only.</i></small>)
                                    </label>
                                    <input type="text" class="form-control form-control-sm" id="startWith"
                                        formControlName="txtPrefix" (input)="onStartWithInput($event)" appEnterDirective
                                        [onEnterKey]="useEnterKey">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="mb-2">
                                    <label class="form-label">Series From<span class="mandatory">*</span>
                                        (<small><i class="mdi mdi-information">Note: numbers only.</i></small>)
                                    </label>
                                    <input type="number" class="form-control form-control-sm" id="seriesFrom"
                                        formControlName="txtSeriesFrom" (input)="onSeriesFromInput($event)"
                                        appEnterDirective [onEnterKey]="useEnterKey"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || awbStockForm.get('txtSeriesFrom')?.touched) && awbStockForm.get('txtSeriesFrom')?.errors}">
                                    <div *ngIf="(isFormSubmitted || awbStockForm.get('txtSeriesFrom')?.touched) && awbStockForm.get('txtSeriesFrom')?.errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbStockForm.get('txtSeriesFrom').errors.required">Series From is
                                            required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-2">
                                <div class="mb-2">
                                    <label for="count" class="form-label">Count <span class="mandatory">*</span></label>
                                    <ng-select id="count" placeholder="Select" formControlName="ddlCount"
                                        [items]="countList" [appendTo]="'body'" appEnterDirective
                                        [onEnterKey]="useEnterKey"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || awbStockForm.get('ddlCount')?.touched) && awbStockForm.get('ddlCount')?.errors}">
                                    </ng-select>

                                    <div *ngIf="(isFormSubmitted || awbStockForm.get('ddlCount')?.touched) && awbStockForm.get('ddlCount')?.errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbStockForm.get('ddlCount').errors.required">Count is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="mt-3">
                                    <div class="button-items">
                                        <button type="submit" class="btn btn-primary btn-sm w-sm"
                                            [disabled]="isAddDisable" appEnterDirective
                                            [onEnterKey]="useEnterKey">Add</button>
                                        <button type="button" (click)="resetForm()"
                                            class="btn btn-secondary btn-sm w-sm">Clear</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-template>
                <ng-template #Config>
                    <div>
                        <app-page-title title=" "></app-page-title>
                        <form [formGroup]="awbConfigForm">
                            <div class="row">
                                <div class="col-md-6 grid-container">

                                    <div class="table-responsive">
                                        <table class="table table-bordered border-top ">
                                            <thead class="table-dark">
                                                <tr>
                                                    <th class="text-nowrap" style="width: 90%;">Description</th>
                                                    <th class="text-nowrap" style="width: 10%;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container formArrayName="configDetails">
                                                    <tr class="event-type"
                                                        *ngFor="let detail of configDetails.controls;let i = index"
                                                        [formGroupName]="i">
                                                        <td class="text-nowarp" style="width: 90%;">
                                                            <label><b>{{detail.get('title').value}}</b></label>
                                                        </td>
                                                        <td style="width: 10%;">
                                                            <div class="form-check d-flex justify-content-center">
                                                                <input class="form-check-input" type="checkbox"
                                                                    formControlName="ischecked" appEnterDirective
                                                                    [onEnterKey]="useEnterKey">
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <div class="button-items">
                                        <button type="button" class="btn btn-primary btn-md" (click)="upsertAwbConfig()"
                                            appEnterDirective [onEnterKey]="useEnterKey">Save</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="isStockTabActive">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase"> Stocks List </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [gridOptions]="gridOptions" [pagination]="true" (gridReady)="onGridReady($event)">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>
